export default "__VITE_ASSET__B0GEjIA6__"